import {gql} from '@apollo/client';

import {RoleAssignee} from '../fragments';

const RolePermissionsFragment = gql`
    fragment RolePermissions on Role {
        id: roleId
        roleId
        title
        locked
        source
        target
        institutionSetIds
        assignees {
            ...RoleAssignee
        }
        permissions {
            permissionId: id
            granted
            locked
        }
    }

    ${RoleAssignee}
`;

export const PermissionTree = gql`
    fragment PermissionTree on PermissionTree {
        ...Permission
        ... on PermissionNode {
            permissions {
                ...Permission
                ... on PermissionNode {
                    permissions {
                        ...Permission
                        ... on PermissionNode {
                            permissions {
                                ...Permission
                            }
                        }
                    }
                }
            }
        }
    }
    fragment Permission on PermissionTree {
        id
        title
        code
        description
        __typename
    }
`;

export const GetRolesAndPermissions = gql`
    query GetRolesAndPermissions(
        $institutionSetIds: [InstitutionSetId!]!
        $source: RoleSource!
        $target: RoleTarget!
        $roleIds: [RoleId!]
        $first: Int!
    ) {
        roles {
            list(
                institutionSetIds: $institutionSetIds
                source: $source
                target: $target
                roleIds: $roleIds
                first: $first
            ) {
                permissions {
                    ...PermissionTree
                }
                roles {
                    ...RolePermissions
                }
            }
        }
    }

    ${RolePermissionsFragment}
    ${PermissionTree}
`;

export const SavePermissions = gql`
    mutation SavePermissions($roles: [RoleInput!]!, $preview: Boolean!) {
        roles {
            upsert(roles: $roles, preview: $preview) {
                ...RolePermissions
            }
        }
    }

    ${RolePermissionsFragment}
`;
